<div class="d-flex align-items-center justify-content-between">
  <wilson-score-bar
    [widthPercentage]="score?.widthPercentage ?? 0"
    [backgroundColor]="score?.backgroundColor ?? ''"
  ></wilson-score-bar>

  <div class="fw-normal text-dark score-value">
    {{ score?.value ?? '0.0' }}
  </div>
</div>
